import { dataHooks } from '@wix/data-hooks'

export const secondTryDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  disclaimer: {}
  skip: {}
  next: {}
  radio: { optionKey: string }
}>('2nd-try')
